import { render } from "./InboxCard.vue?vue&type=template&id=26ad2260"
import script from "./InboxCard.vue?vue&type=script&lang=js"
export * from "./InboxCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__